import React from 'react';
import { Group, Circle, Path } from 'react-konva';
import { CanvasComment } from '../types';

interface CommentBubbleProps {
  comment: CanvasComment;
  scale: number;
  isSelected: boolean;
  onClick: (evt: any) => void;
}

/**
 * A comment bubble icon rendered on the Konva canvas.
 * Shows a chat bubble icon at the comment's position.
 */
const CommentBubble: React.FC<CommentBubbleProps> = ({
  comment,
  scale,
  isSelected,
  onClick,
}) => {
  // Size constants (in image coordinates)
  const bubbleSize = 24 / scale;
  const iconSize = 16 / scale;
  
  // Colors based on resolved state
  const fillColor = comment.resolved ? '#9ca3af' : '#f59e0b'; // gray-400 or amber-500
  const strokeColor = comment.resolved ? '#6b7280' : '#d97706'; // gray-500 or amber-600
  const selectedStroke = '#3b82f6'; // blue-500
  
  // Chat bubble SVG path (scaled)
  // Original viewBox: 0 0 24 24
  const pathScale = iconSize / 24;
  
  return (
    <Group
      x={comment.x}
      y={comment.y}
      onClick={(e) => {
        e.cancelBubble = true;
        onClick(e);
      }}
      onTap={(e) => {
        e.cancelBubble = true;
        onClick(e);
      }}
    >
      {/* Background circle */}
      <Circle
        x={0}
        y={0}
        radius={bubbleSize / 2}
        fill={fillColor}
        stroke={isSelected ? selectedStroke : strokeColor}
        strokeWidth={(isSelected ? 3 : 2) / scale}
        shadowColor="rgba(0,0,0,0.3)"
        shadowBlur={4 / scale}
        shadowOffsetY={2 / scale}
      />
      
      {/* Chat icon - using a simple path for a speech bubble */}
      <Path
        x={-iconSize / 2}
        y={-iconSize / 2}
        data="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
        fill="white"
        scaleX={pathScale}
        scaleY={pathScale}
      />
      
      {/* Unresolved indicator dot */}
      {!comment.resolved && (
        <Circle
          x={bubbleSize / 3}
          y={-bubbleSize / 3}
          radius={5 / scale}
          fill="#ef4444"
          stroke="white"
          strokeWidth={1.5 / scale}
        />
      )}
    </Group>
  );
};

export default CommentBubble;
